<ng-template #jumpToElement>
  <app-qa-question-index
    [hideLabel]="true"
    [truncateAfter]="20"
    [questionnaire]="questionnaire"
    (done)="jumpToQuestionPopover.close()"
  >
  </app-qa-question-index>
</ng-template>

<div class="qa-editor" #qaEditor>
  <app-qa-io-overlay
    [visible]="ioOverlayVisible"
    [questionnaire]="questionnaire"
    [pathHashMap]="pathHashMap"
    (onHide)="ioOverlayVisible = false"
    (onImportQuestionnaire)="questionnaire = $event"
  >
  </app-qa-io-overlay>

  <app-questionnaire-translation
    [visible]="translationOverlayVisible"
    [questionnaire]="questionnaire"
    (onHide)="translationOverlayVisible = false"
    (onUpdateQuestionnaire)="questionnaire = $event"
  >
  </app-questionnaire-translation>

  <h2 class="mb-4">
    {{_(KEYS.EDITOR.QUESTIONNAIRE_EDITOR)}}
  </h2>

  <div class="qa-meta qa-padding qa-border-bottom qa-bg-gray" #qaMeta>
    <input
      class="qa-title form-control"
      placeholder="{{_(KEYS.EDITOR.ENTER_TITLE)}}"
      [(ngModel)]="questionnaire.meta.title[locale]">

    <div class="qa-status input-group">
      <span class="input-group-addon">{{_(KEYS.EDITOR.STATUS)}}</span>
      <select class="form-control qa-custom-select" [(ngModel)]="questionnaire.status">
        <option value="draft">{{_(KEYS.EDITOR.DRAFT)}}</option>
        <option value="active">{{_(KEYS.EDITOR.APPROVED)}}</option>
      </select>
      <span class="input-group-addon">
        {{_(KEYS.EDITOR.REV)}}
        {{questionnaire.revision <= 0 ? 1 : questionnaire.revision}}
      </span>
    </div>


    <div class="qa-filtergroup input-group">
      <app-select2
        cmpCssClasses="qa-filtergroup"
        label="{{_(KEYS.EDITOR.FILTER_GROUPS)}}"
        [hideButton]="true"
        [multiple]="true"
        [options]="filtergroupSelectOpts"
        [(selected)]="questionnaire.meta.tags"
      >
        <option *ngFor="let filtergroup of filtergroups" value="{{filtergroup.id}}">
          {{filtergroup.name[locale]}}
        </option>
      </app-select2>
    </div>

    <div class="qa-spacing"></div>

    <div class="qa-buttons">
      <button
        class="btn btn-primary qa-upper"
        [attr.disabled]="saveInProgress? true: null"
        (click)="onSaveQuestionnaire()"
      >
        <i class="fa fa-save"></i>
        {{_(KEYS.EDITOR.SAVE)}}
      </button>
    </div>
    <div class="qa-display-settings">
      <div class="d-inline-block">
        <div ngbDropdown>
          <button class="btn btn-primary qa-upper mr-1" ngbDropdownToggle>
            {{_(KEYS.EDITOR.SHOW)}}
          </button>
          <div ngbDropdownMenu>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onFoldQuestions()">
              {{_(KEYS.EDITOR.NO_CONTENT)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionContents()">
              {{_(KEYS.EDITOR.ALL_CONTENT)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionImages()">
              {{_(KEYS.EDITOR.ALL_IMAGES)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionVideos()">
              {{_(KEYS.EDITOR.ALL_VIDEOS)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionAudio()">
              {{_(KEYS.EDITOR.ALL_AUDIO)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionDescriptions()">
              {{_(KEYS.EDITOR.ALL_DESCRIPTIONS)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionConditions()">
              {{_(KEYS.EDITOR.ALL_DEPENDENCIES)}}
            </button>
            <button class="dropdown-item qa-upper qa-cursor-pointer" (click)="tabs.onExpandQuestionVariables()">
              {{_(KEYS.EDITOR.ALL_VARIABLES)}}
            </button>
          </div>
        </div>
      </div>
      <button class="btn btn-primary mr-1" (click)="tabs.onExpandQuestions()" ngbTooltip="{{_(KEYS.EDITOR.EXPAND_ELEMENTS)}}">
        <i class="fa fa-expand"></i>
      </button>
      <button class="btn btn-primary mr-1" (click)="tabs.onFoldQuestions()" ngbTooltip="{{_(KEYS.EDITOR.FOLD_ELEMENTS)}}">
        <i class="fa fa-compress"></i>
      </button>
      <span ngbTooltip="{{_(KEYS.EDITOR.JUMP_TO_ELEMENT)}}" style="display: inline-block;">
        <button
          class="btn btn-primary mr-1"
          [ngbPopover]="jumpToElement"
          placement="top-left"
          popoverTitle="{{_(KEYS.EDITOR.JUMP_TO_ELEMENT)}}"
          triggers="manual" container="body"
          #jumpToQuestionPopover="ngbPopover"
          [disabled]="pageViewEnabled"
          (click)="onJumpToQuestion(jumpToQuestionPopover)"
        >
          <i class="fa fa-forward"></i>
        </button>
      </span>
      <button
        class="btn mr-1"
        [ngClass]="{'btn-primary': !pageViewEnabled, 'btn-success': pageViewEnabled}"
        (click)="togglePageView()"
        ngbTooltip="{{_(KEYS.EDITOR.PAGE_VIEW)}}"
      >
        <i class="fa fa-file-text-o"></i>
      </button>
      <app-qa-preview [questionnaire]="questionnaire"></app-qa-preview>
      <button class="btn btn-secondary ml-1" (click)="ioOverlayVisible = true">
        <i class="fa fa-retweet"></i>
      </button>
      <button *ngIf="canCloudTranslate" class="btn btn-primary ml-1" (click)="translationOverlayVisible = true">
        <i class="fa fa-flag"></i>
      </button>

      <div class="language-icons d-inline-block" [ngClass]="{'center': getLangCodes().length <= 17}">
        <span class="flags" *ngFor="let lang of getLangCodes()">
          <span
            class="flag-icon flag-icon-{{flagIconCodeMap[lang]}}"
            [ngbTooltip]="translateLanguage(languages[lang])"
            style="margin-left: 5px;"
          ></span>
        </span>
        <ng-container *ngIf="getLangCodes().length <= 17">
          <br>&nbsp;
        </ng-container>
      </div>



    </div>
    <div class="qa-bar-info qa-upper">
      <div>
        {{questionnaire.questions.length}} {{_(KEYS.EDITOR.ELEMENTS)}}
      </div>
    </div>
    <div class="qa-bar-control">
      <button
        class="btn btn-primary mr-1"
        ngbTooltip="{{_(KEYS.EDITOR.FULL_SCREEN)}}"
        (click)="domHelper.toggleCls(qaEditor, 'maximized')"
      >
        <i class="fa fa-toggle-maximize"></i>
      </button>
      <button
        class="btn btn-primary mr-1"
        ngbTooltip="{{_(KEYS.EDITOR.OPTIONS)}}"
        (click)="domHelper.toggleCls(qaMeta, 'expanded', [qaMetaTab])"
      >
        <i class="fa fa-toggle-expand"></i>
      </button>
    </div>
  </div>
  <div class="qa-meta-tab mt-3" #qaMetaTab>
    <ul ngbNav #nav="ngbNav" class="nav-tabs">
      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-copy"></i> {{_(KEYS.EDITOR.DESCRIPTION)}}</a>
        <ng-template ngbNavContent>
          <div class="mt-3" [froalaEditor]="defaultEditorOptions" [(froalaModel)]="questionnaire.meta.description[locale]"></div>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-image"></i> {{_(KEYS.EDITOR.IMAGE)}}</a>
        <ng-template ngbNavContent>
          <div>
            <ng-container>
              <div class="card qa-card-inline-block mt-3">
                <div class="card-footer">
                  <div class="btn-toolbar justify-content-between">
                    <div class="justify-content-between">
                      <label class="btn btn-primary qa-no-margin mr-1" #qaEditorImageUpload (click)="onOpenMediaCenterModal()">
                        <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_IMAGE)}}
                      </label>
                    </div>
                    <button
                      class="btn btn-danger"
                      (click)="onDeleteImage()"
                      [attr.disabled]="!(questionnaire.meta.asset.image && questionnaire.meta.asset.image.filename[locale])? true: null">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <img
                    class="card-img-top qa-editor-image mb-3"
                    *ngIf="questionnaire.meta.asset.image && questionnaire.meta.asset.image.filename[locale]; else qaEditorImgPlaceholder"
                    [src]="mediaCenter.getAssetUrl(questionnaire.meta.asset.image, locale)"
                    (click)="onOpenMediaCenterModal(questionnaire.meta.asset.image)" />
                  <ng-template #qaEditorImgPlaceholder>
                    <img
                      class="card-img-top qa-editor-image mb-3"
                      src="/assets/images/placeholder.png"
                      (click)="onOpenMediaCenterModal()"/>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </div>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-pencil-square-o"></i> {{_(KEYS.EDITOR.FILL_OPTIONS)}}</a>
        <ng-template ngbNavContent>
          <form class="pdf-opts">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.fill.forceMandatory"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.FORCE_MANDATORY)}}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.fill.skipList"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.SKIP_LIST)}}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.fill.skipSubmitConfirmation"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.SKIP_SUBMIT_CONFIRMATION)}}</label>
            </div>
          </form>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-sort-numeric-asc"></i> {{_(KEYS.EDITOR.SCORING)}}</a>
        <ng-template ngbNavContent>
          <app-qa-scoring-variables [questionnaire]="questionnaire"></app-qa-scoring-variables>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-calculator"></i> {{_(KEYS.EDITOR.FORMULA_VARIABLES)}}</a>
        <ng-template ngbNavContent>
          <app-qa-formula-variables [questionnaire]="questionnaire"></app-qa-formula-variables>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-file-pdf-o"></i> {{_(KEYS.EDITOR.GDT)}}</a>
        <ng-template ngbNavContent>
          <form class="pdf-opts">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.gdt.addQuestionnaireTitle"
              >
              <label class="form-check-label">
                {{_(KEYS.EDITOR.ADD_QUESTIONNAIRE_TITLE_TO_GDT)}}
                <button
                  class="btn btn-sm btn-primary label-btn"
                  (click)="onGdtMetaTitleVariablesModal()"
                  [attr.disabled]="!questionnaire.meta.options.gdt.addQuestionnaireTitle ? true : null">
                  <i class="fa fa-code"></i>
                </button>
              </label>
              <br>
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.gdt.addScoring"
                (change)="addDefaultGdtScoringVariables()"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.ADD_SCORING_TO_GDT)}}</label>
              <ng-container *ngIf="questionnaire.meta.options.gdt.addScoring && hasScoring()">
                <div class="card gdt-scoring-card">
                  <ng-container *ngFor="let scoringVar of getScoringVariables()">
                    <label class="form-check-label">
                      {{scoringVar}}
                      <button
                        class="btn btn-sm btn-primary label-btn"
                        (click)="onGdtMetaScoringVariablesModal(scoringVar)">
                        <i class="fa fa-code"></i>
                      </button>
                    </label>
                  </ng-container>
                </div>
              </ng-container>
              <div>
                <input
                  type="checkbox"
                  class="form-check-input"
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="questionnaire.meta.options.gdt.addFormulaResults"
                  (change)="addDefaultGdtFormulaVariables()"
                >
                <label class="form-check-label">{{_(KEYS.EDITOR.ADD_FORMULA_RESULTS_TO_GDT)}}</label>
                <ng-container *ngIf="questionnaire.meta.options.gdt.addFormulaResults && hasFormulaVariables()">
                  <div class="card gdt-scoring-card">
                    <ng-container *ngFor="let formulaVar of getFormulaVariables()">
                      <label class="form-check-label">
                        {{formulaVar}}
                        <button
                          class="btn btn-sm btn-primary label-btn"
                          (click)="onGdtMetaFormulaVariablesModal(formulaVar)">
                          <i class="fa fa-code"></i>
                        </button>
                      </label>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </form>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-envelope-o"></i> {{_(KEYS.EDITOR.MAIL)}}</a>
        <ng-template ngbNavContent>
          <ul ngbNav #mailNav="ngbNav" class="nav-tabs">
            <li [ngbNavItem]="1">
              <a ngbNavLink><i class="fa fa-user"></i> {{_(KEYS.EDITOR.USER)}}</a>
              <ng-template ngbNavContent>
                <form class="pdf-opts">
                  <br>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="questionnaire.meta.options.mail.user.internalPdf"
                    >
                    <label class="form-check-label">{{_(KEYS.EDITOR.SEND_INTERNAL_PDF)}}</label>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="questionnaire.meta.options.mail.user.filledPdf"
                    >
                    <label class="form-check-label">{{_(KEYS.EDITOR.SEND_FILLED_PDF)}}</label>
                  </div>
                </form>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink><i class="fa fa-pencil-square-o"></i> {{_(KEYS.EDITOR.FILLER)}}</a>
              <ng-template ngbNavContent>
                <form class="pdf-opts">
                  <br>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="questionnaire.meta.options.mail.filler.internalPdf"
                    >
                    <label class="form-check-label">{{_(KEYS.EDITOR.SEND_INTERNAL_PDF)}}</label>
                  </div>
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="questionnaire.meta.options.mail.filler.filledPdf"
                    >
                    <label class="form-check-label">{{_(KEYS.EDITOR.SEND_FILLED_PDF)}}</label>
                  </div>
                </form>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="mailNav"></div>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-file-pdf-o"></i> {{_(KEYS.EDITOR.PDF)}}</a>
        <ng-template ngbNavContent>
          <form class="pdf-opts">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.pdf.skipUnsigned"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.SKIP_UNSIGNED_PDF)}}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.pdf.generateInternal"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.GENERATE_INTERNAL_PDF)}}</label>
            </div>
          </form>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem *ngIf="feature.pdf.forms">
        <a ngbNavLink><i class="fa fa-file-pdf-o"></i> {{_(KEYS.EDITOR.PDF_FORMS)}}</a>
        <ng-template ngbNavContent>
          <div class="alert alert-info mt-3 qa-pdf-forms-info">
            <div class="font-weight-bold">
              <i class="fa fa-info-circle"></i>
              {{_(KEYS.EDITOR.PDF_FORMS_INTRO)}}
            </div>
            <div>
              {{_(KEYS.EDITOR.PDF_FORMS_HELP)}}
            </div>
          </div>
          <form class="pdf-form-opts">
            <app-pdf-form-select
              [selected]="questionnaire.meta.options.pdf.forms"
              (selectedChange)="questionnaire.meta.options.pdf.forms = $event">
            </app-pdf-form-select>
          </form>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-code"></i> PDF Mapping</a>
        <ng-template ngbNavContent>
          <form class="pdf-form-opts">
            <app-qa-map-variables></app-qa-map-variables>
          </form>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-external-link"></i> {{_(KEYS.EDITOR.EXTERN_VARIABLES)}}</a>
        <ng-template ngbNavContent>
          <app-qa-extern-variables [questionnaire]="questionnaire"></app-qa-extern-variables>
          <hr>
        </ng-template>
      </li>

      <li ngbNavItem>
        <a ngbNavLink><i class="fa fa-table"></i> {{_(KEYS.EDITOR.EXCEL)}}</a>
        <ng-template ngbNavContent>
          <form class="pdf-opts">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="questionnaire.meta.options.excel.omitPatientData"
              >
              <label class="form-check-label">{{_(KEYS.EDITOR.OMIT_PATIENT_DATA)}}</label>
            </div>
          </form>
          <hr>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
  <div class="qa-questions mt-3">
    <app-qa-add-question
      [pageViewEnabled]="pageViewEnabled"
      [pages]="pages"
      [currentPageIndex]="currentPageIndex"
    ></app-qa-add-question>

    <ng-container *ngIf="questionnaire">
      <div class="qa-page-navigation" *ngIf="pageViewEnabled && pages.length > 0">
        <app-select2
          [hideButton]="true"
          [hideLabel]="true"
          [options]="pageSelectOptions"
          [(selected)]="currentPageIndex"
          (selectedChange)="onPageChange($event)"
        >
          <option *ngFor="let page of pages; let i = index" [value]="i">
            {{_(KEYS.EDITOR.PAGE)}} {{i + 1}}{{page.title ? ': ' + page.title : ''}}
          </option>
        </app-select2>
        <span class="qa-page-info ml-2">
          {{_(KEYS.EDITOR.PAGE)}} {{currentPageIndex + 1}} / {{pages.length}}
        </span>
        <button
          class="btn btn-success qa-add-page-btn"
          (click)="addNewPage()"
          ngbTooltip="{{_(KEYS.EDITOR.ADD_PAGE)}}"
        >
          <i class="fa fa-plus"></i>
        </button>
        <button
          class="btn btn-success qa-copy-page-btn"
          (click)="copyCurrentPage()"
          ngbTooltip="{{_(KEYS.EDITOR.COPY_PAGE)}}"
        >
          <i class="fa fa-copy"></i>
        </button>
        <button
          class="btn btn-danger qa-delete-page-btn"
          (click)="deleteCurrentPage()"
          ngbTooltip="{{_(KEYS.EDITOR.DELETE_PAGE)}}"
        >
          <i class="fa fa-trash"></i>
        </button>
      </div>

      <!-- flat view: iterate directly over questions for better performance -->
      <div
        class="elements"
        [dragula]='"elements-bag"'
        [dragulaModel]="questionnaire.questions"
        *ngIf="!pageViewEnabled"
      >
        <ng-container *ngFor="let question of questionnaire.questions; let i = index; trackBy: trackByQuestion">
          <ng-container *ngIf="mappings[question.format]">
            <ng-container
              *ngComponentOutlet="mappings[question.format].main;
              ndcDynamicInputs: {position: i, feature: feature, question: question, pageViewEnabled: false, isFirstOnPage: false, isLastOnPage: false, mapping: mappings[question.extra ? question.format + '#' + question.extra : question.format]};">
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <!-- page view: iterate over filtered visible questions -->
      <div
        class="elements"
        [dragula]='"elements-bag"'
        [dragulaModel]="visibleQuestions"
        *ngIf="pageViewEnabled"
      >
        <ng-container *ngFor="let item of visibleQuestions; trackBy: trackByQuestionId">
          <ng-container *ngIf="mappings[item.question.format]">
            <ng-container
              *ngComponentOutlet="mappings[item.question.format].main;
              ndcDynamicInputs: {position: item.realIndex, feature: feature, question: item.question, pageViewEnabled: true, isFirstOnPage: item.isFirstOnPage, isLastOnPage: item.isLastOnPage, pages: pages, currentPageIndex: currentPageIndex, mapping: mappings[item.question.extra ? item.question.format + '#' + item.question.extra : item.question.format]};">
            </ng-container>
          </ng-container>
        </ng-container>
      </div>

      <div class="qa-page-nav-buttons" *ngIf="pageViewEnabled && pages.length > 0">
        <button
          class="btn btn-success"
          [disabled]="!canGoToPage(-1)"
          (click)="goToPage(-1)"
        >
          <i class="fa fa-arrow-left"></i> {{_(KEYS.EDITOR.PREVIOUS_PAGE)}}
        </button>
        <button
          class="btn btn-success"
          [disabled]="!canGoToPage(1)"
          (click)="goToPage(1)"
        >
          {{_(KEYS.EDITOR.NEXT_PAGE)}} <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </ng-container>

    <div class="mt-3" *ngIf="questionnaire && questionnaire.questions && questionnaire.questions.length > 5">
      <app-qa-add-question
        [pageViewEnabled]="pageViewEnabled"
        [pages]="pages"
        [currentPageIndex]="currentPageIndex"
      ></app-qa-add-question>
    </div>

    <div class="qa-buttons mt-3">
      <button
        class="btn btn-primary qa-upper"
        [attr.disabled]="saveInProgress? true: null"
        (click)="onSaveQuestionnaire()"
      >
        <i class="fa fa-save"></i>
        {{_(KEYS.EDITOR.SAVE)}}
      </button>
    </div>
  </div>
</div>
